import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import Routes from './routes'

import 'typeface-roboto'
import 'typeface-nunito-sans'
import 'material-design-icons/iconfont/material-icons.css'
import 'normalize-css'

class App extends Component {
  render() {
    return (
      <Routes />
    )
  }
}

export default withRouter(App);
